import { automationAllowedLimit } from "@/functions/automationFunctions";
import { getChatbotUserStatus } from "@/common/functions";
import McFixAlertMaintenance from "@/components/McComponents/McFixAlertMaintenance";
import PlanUpgradeBanner from "@/components/PlanUpgradeBanner";
export default {
  components: {
    McFixAlertMaintenance,
    PlanUpgradeBanner
  },
  computed: {
    keepAliveComponents() {
      // Only keep AutomationList and AutomationClassic alive when navigating to/from automation report
      if (this.shouldKeepAutomationAlive) {
        return ["AutomationList", "AutomationClassic"];
      }
      return [];
    }
  },
  created() {
    setTimeout(() => {
      this.isMainUser = getChatbotUserStatus(this);
    }, 5000);

    // Expose this instance globally for keep-alive management
    window.appLayout = this;
  },
  beforeUnmount() {
    // Clean up global reference
    if (window.appLayout === this) {
      delete window.appLayout;
    }
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name && to.name === "AudienceList") {
        this.showRecipients = true;
        this.showSidebar = true;
      }

      // Track navigation between automation pages and automation report/preview
      const automationPages = ["AutomationList", "AutomationClassic"];
      const automationDetailPages = ["AutomationReport", "AutomationPreview", "AutomationList", "AutomationClassic"];
      const isFromAutomationPage = automationPages.includes(from.name);
      const isToAutomationDetail = automationDetailPages.includes(to.name);
      const isToAutomationPage = automationPages.includes(to.name);
      const isFromAutomationDetail = automationDetailPages.includes(from.name);

      // Enable keep-alive when navigating from automation page to automation detail pages
      if (isFromAutomationPage && isToAutomationDetail) {
        this.shouldKeepAutomationAlive = true;
      }
      // Keep keep-alive enabled when returning from automation detail pages to automation page
      else if (isFromAutomationDetail && isToAutomationPage) {
        this.shouldKeepAutomationAlive = true;
      }
      // Disable keep-alive when navigating to other pages (not automation detail pages)
      else if (!isToAutomationDetail && !isFromAutomationDetail) {
        this.shouldKeepAutomationAlive = false;
      }
    }
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("login_data")),
      showReport: false,
      showGallery: false,
      showRecipients: false,
      showCreate: false,
      isMainUser: false,
      showSidebar: true,
      showAdvanced: automationAllowedLimit(),
      permission: localStorage.getItem("permission"),
      allowAudience: parseInt(window.localStorage.getItem("allowAudience")),
      shouldKeepAutomationAlive: false,
      showSidebarPages: ["WebhookEdit", "WebHookList", "WebhookCreate", "AudienceList", "AudienceDetails", "SegmentAudienceDetails", "RecipientAudienceDetails", "SegmentList", "SegmentAudienceList", "RecipientAudienceList", "WebformActivity", "Profile", "AutomationActivity", "AccountPreferences", "AutomationList", "AutomationClassic"]
    };
  },
  methods: {
    closeAll(menu = "") {
      if (menu) {
        var val = this[menu];
      }
      this.showReport = false;
      this.showGallery = false;
      this.showRecipients = false;
      this.showCreate = false;
      if (menu) {
        this[menu] = val;
      }
    },
    enableAutomationKeepAlive() {
      this.shouldKeepAutomationAlive = true;
    },
    disableAutomationKeepAlive() {
      this.shouldKeepAutomationAlive = false;
    }
    // redirect(menu) {
    //   if (!this.redirectMenus.includes(menu)) {
    //     return;
    //   }
    //   switch (menu) {
    //     case "showRecipients":
    //       if (this.allowAudience) {
    //         this.$router.push("/audience/list");
    //         this.showRecipients = true;
    //       } else {
    //         this.$router.push("/recipients");
    //       }
    //       break;
    //     case "showCreate":
    //       this.$router.push("/campaign");
    //       this.showCreate = true;
    //       break;
    //   }
    // },
  }
};